import { Link } from "react-router-dom";
import EyeOpen from "../../../components/Atomos/Icons/EyeOpen";
import PencilEdit from "../../../components/Atomos/Icons/PencilEdit";
import { TrashCan } from "../../../components/Atomos/Icons/TrashCan";
import { IReferral } from "../../../Services/Referral";
import { formatReferralWhen, formatUsDate, relationshipLabel, shortFirmName } from "../referralFormat";
import {
  referralHeadClass,
  referralRowClass,
  referralStaffCellClass,
  referralStaffHeadCellClass,
  referralStaffIconActionClass,
  referralStaffPartyClass,
  referralStaffTableClass,
  ReferralTable,
} from "../referralSurface";

const columns = ["#", "Type", "Sub. Date", "Ref. Date", "ID", "Story ID", "By Name", "By Firm", "To Name", "To Firm", "Sub. By Firm", "Transaction", "Estimated Fees", "Detail", "Action"];

type Props = {
  rows: IReferral[];
  firstNumber: number;
  basePath: string;
  onDelete: (id: string) => void;
};

export default function StaffReferralTable({ rows, firstNumber, basePath, onDelete }: Props) {
  return (
    <ReferralTable measureKey={rows.length} className={referralStaffTableClass}>
      <thead className={referralHeadClass}>
        <tr>
          {columns.map((label) => (
            <th key={label} className={referralStaffHeadCellClass}>{label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr className="bg-white">
            <td className={referralStaffCellClass} colSpan={columns.length}>No referrals found.</td>
          </tr>
        ) : rows.map((row, index) => (
          <tr key={row.id} className={referralRowClass(index)}>
            <td className={referralStaffCellClass}>{firstNumber + index}</td>
            <td className={referralStaffCellClass}>{relationshipLabel(row)}</td>
            <td className={referralStaffCellClass}>{formatUsDate(row.submissionDate)}</td>
            <td className={referralStaffCellClass}>{formatReferralWhen(row)}</td>
            <td className={referralStaffCellClass}>{row.legacyId || row.id}</td>
            <td className={referralStaffCellClass}>{row.storyId}</td>
            <td className={`${referralStaffCellClass} ${referralStaffPartyClass}`}>{row.sendByName}</td>
            <td className={referralStaffCellClass} title={row.firmByName}>{shortFirmName(row.firmByName)}</td>
            <td className={`${referralStaffCellClass} ${referralStaffPartyClass}`}>{row.sendToName}</td>
            <td className={referralStaffCellClass} title={row.firmToName}>{shortFirmName(row.firmToName)}</td>
            <td className={referralStaffCellClass} title={row.submittedByFirmName}>{shortFirmName(row.submittedByFirmName)}</td>
            <td className={referralStaffCellClass}>{row.referralType}</td>
            <td className={referralStaffCellClass}>{row.estimatedFeesDetail}</td>
            <td className={referralStaffCellClass}>{(row.detail || "").slice(0, 60)}</td>
            <td className={`${referralStaffCellClass} whitespace-nowrap`}>
              <Link className={referralStaffIconActionClass} to={`${basePath}/view/${row.id}`} title="View Detail" aria-label="View Detail"><EyeOpen /></Link>
              <Link className={referralStaffIconActionClass} to={`${basePath}/edit/${row.id}`} title="Edit Referral" aria-label="Edit Referral"><PencilEdit className="h-4 w-4" /></Link>
              <button type="button" className={referralStaffIconActionClass} onClick={() => onDelete(row.id)} title="Delete Referral" aria-label="Delete Referral"><span className="block h-4 w-4"><TrashCan /></span></button>
            </td>
          </tr>
        ))}
      </tbody>
    </ReferralTable>
  );
}
